import {
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridRowCountSelector,
  gridPageSizeSelector,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function getPageButtons(page, pageCount) {
  if (pageCount <= 5) return Array.from({ length: pageCount }, (_, i) => i);
  if (page <= 2) return [0, 1, 2, "...", pageCount - 1];
  if (page >= pageCount - 3) return [0, "...", pageCount - 3, pageCount - 2, pageCount - 1];
  return [0, "...", page - 1, page, page + 1, "...", pageCount - 1];
}

const pageBtnSx = (active) => ({
  background: "transparent",
  border: `1px solid ${active ? "rgba(253,185,64,0.55)" : "rgba(255,255,255,0.12)"}`,
  borderRadius: "6px",
  color: active ? "#FDB940" : "rgba(255,255,255,0.55)",
  cursor: active ? "default" : "pointer",
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.78rem",
  fontWeight: active ? 600 : 400,
  flexShrink: 0,
  "&:hover": active ? {} : { borderColor: "rgba(255,255,255,0.3)", color: "#fff" },
});

const navBtnSx = (disabled) => ({
  background: "transparent",
  border: "1px solid rgba(255,255,255,0.12)",
  borderRadius: "6px",
  color: disabled ? "rgba(255,255,255,0.2)" : "rgba(255,255,255,0.55)",
  cursor: disabled ? "default" : "pointer",
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1rem",
  flexShrink: 0,
  "&:hover": disabled ? {} : { borderColor: "rgba(255,255,255,0.3)", color: "#fff" },
});

export default function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const pageCount = Math.ceil(rowCount / pageSize) || 1;

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: "20px", py: "10px", width: "100%" }}>
      <Typography sx={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.4)" }}>
        Page {page + 1} of {pageCount || 1} · {pageSize} rows per page
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <Box component="button" onClick={() => apiRef.current.setPage(page - 1)} disabled={page === 0} sx={navBtnSx(page === 0)}>
          ‹
        </Box>
        {getPageButtons(page, pageCount).map((p, i) =>
          p === "..." ? (
            <Typography key={`e${i}`} sx={{ color: "rgba(255,255,255,0.3)", px: "4px", fontSize: "0.82rem", lineHeight: 1 }}>…</Typography>
          ) : (
            <Box key={p} component="button" onClick={() => apiRef.current.setPage(p)} sx={pageBtnSx(p === page)}>
              {p + 1}
            </Box>
          )
        )}
        <Box component="button" onClick={() => apiRef.current.setPage(page + 1)} disabled={page >= pageCount - 1} sx={navBtnSx(page >= pageCount - 1)}>
          ›
        </Box>
      </Box>
    </Box>
  );
}
